(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cabana-launch-countdown"] && !Shopify.designMode) return;
  try {
    
(function(){function pad(n){return String(n).padStart(2,'0')}function initTimer(sectionId,targetStr){var d=document.getElementById('claunch-d-'+sectionId);var h=document.getElementById('claunch-h-'+sectionId);var m=document.getElementById('claunch-m-'+sectionId);var s=document.getElementById('claunch-s-'+sectionId);if(!d||!h||!m||!s)return;var target=new Date(targetStr).getTime();if(isNaN(target))return;function tick(){var now=Date.now();var diff=target-now;if(diff<=0){d.textContent=h.textContent=m.textContent=s.textContent='00';return}var days=Math.floor(diff/86400000);diff-=days*86400000;var hrs=Math.floor(diff/3600000);diff-=hrs*3600000;var mins=Math.floor(diff/60000);diff-=mins*60000;var secs=Math.floor(diff/1000);d.textContent=pad(days);h.textContent=pad(hrs);m.textContent=pad(mins);s.textContent=pad(secs)}tick();setInterval(tick,1000)}document.addEventListener('DOMContentLoaded',function(){var timers=document.querySelectorAll('.claunch__timer');timers.forEach(function(el){var id=el.getAttribute('data-section');var target=el.getAttribute('data-target');if(id&&target)initTimer(id,target)});var modals=document.querySelectorAll('.claunch-modal');modals.forEach(function(modal){modal.addEventListener('click',function(e){if(e.target===modal)modal.close()})})})})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
